import {Outlet} from "react-router-dom";

function Auth(){
    return (
            <Outlet />
    )
}
export default Auth;